import {
  GetInstrumentsPayload,
  RetrieveInstrumentTxnsPayload,
  PaginatedSilencedRulesPayload,
} from 'app/modules/instruments/requests';
import { InstrumentSearchPayload } from 'app/modules/search/payload';
import { PaginationPayload } from 'app/shared/pagination/models';

const BASE = ['instruments'];

export const INSTRUMENT_QUERY_KEYS = {
  getInstruments: (
    payload: GetInstrumentsPayload,
    useNewEndpoint?: boolean,
  ) => {
    if (useNewEndpoint) {
      return [...BASE, payload, useNewEndpoint] as const;
    }
    return [...BASE, payload] as const;
  },
  getInstrumentDetails: (
    instrumentId?: string | number,
    useCacheEndpoint?: boolean,
  ) => {
    if (instrumentId === undefined) {
      return [...BASE, 'instrument-details'] as const;
    }
    if (useCacheEndpoint) {
      return [
        ...BASE,
        'instrument-details',
        instrumentId,
        useCacheEndpoint,
      ] as const;
    }
    return [...BASE, 'instrument-details', instrumentId] as const;
  },
  getTransactionSummary: (
    instrumentId: string,
    useCacheEndpoint: boolean = false,
  ) => {
    if (useCacheEndpoint) {
      return [
        ...BASE,
        'transaction-summary',
        instrumentId,
        useCacheEndpoint,
      ] as const;
    }
    return [...BASE, 'transaction-summary', instrumentId] as const;
  },
  getTransactions: (
    instrumentId: string,
    payload: RetrieveInstrumentTxnsPayload,
    useCacheEndpoint: boolean = false,
  ) => {
    if (useCacheEndpoint) {
      return [
        ...BASE,
        'transactions',
        instrumentId,
        payload,
        useCacheEndpoint,
      ] as const;
    }
    return [...BASE, 'transactions', instrumentId, payload] as const;
  },
  getPaginatedSilencedRules: (payload?: PaginatedSilencedRulesPayload) => {
    if (payload === undefined) {
      return [...BASE, 'silenced-rules'] as const;
    }
    return [...BASE, 'silenced-rules', payload] as const;
  },
  getInstrumentAlertsAll: (instrumentExternalId: string) =>
    [...BASE, 'instrument-alerts', instrumentExternalId] as const,
  getInstrumentAlerts: (
    instrumentExternalId: string,
    payload: PaginationPayload,
    useCacheEndpoint: boolean = false,
  ) => {
    if (useCacheEndpoint) {
      return [
        ...INSTRUMENT_QUERY_KEYS.getInstrumentAlertsAll(instrumentExternalId),
        payload,
        useCacheEndpoint,
      ] as const;
    }
    return [
      ...INSTRUMENT_QUERY_KEYS.getInstrumentAlertsAll(instrumentExternalId),
      payload,
    ] as const;
  },
  getInstrumentNotes: (instrumentExternalId: string) =>
    [...BASE, 'instrument-notes', instrumentExternalId] as const,
  getInstrumentSearch: (payload?: InstrumentSearchPayload) =>
    payload
      ? ([...BASE, 'search', payload] as const)
      : ([...BASE, 'search'] as const),
};
